import { Component, OnInit, OnDestroy } from '@angular/core';
import { Transition } from '@uirouter/angular';

@Component({
  selector: 'app-referral-redirect',
  templateUrl: './referral-redirect.component.html',
  standalone: false
})
export class ReferralRedirectComponent implements OnInit, OnDestroy {
  urlToRedirect = this.transition.params().url;

  private readonly delay = 5000;
  private timer?: NodeJS.Timer;

  constructor(private transition: Transition) {}

  ngOnInit() {
    if (!this.urlToRedirect) {
      return;
    }

    this.timer = setTimeout(() => {
      window.location.href = this.urlToRedirect;
    }, this.delay);
  }

  // In case when user click back button we have to stop the timer
  ngOnDestroy() {
    clearTimeout(this.timer);
  }
}
